import * as React from 'react';
import { IBarFilterProps } from '..';

export const BarFilter = ({}: IBarFilterProps) => {
    return <></>;
};
